export interface CategoryArticle {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  image: string;
  slug: string;
}

export interface CategoryGroup {
  id: string;
  name: string;
  description: string;
  icon: string;
  articles: CategoryArticle[];
}

export const categoryGroups: CategoryGroup[] = [
  {
    id: 'all',
    name: '全部文章',
    description: '浏览所有内裤选购指南文章',
    icon: 'ri-grid-line',
    articles: [
      {
        id: 'cat-all-1',
        title: '2026年最值得入手的10款女士内裤推荐',
        excerpt: '经过30天实测对比，从舒适度、透气性、耐穿性三个维度，为你精选出今年最值得购买的女士内裤。',
        date: '2026-08-05',
        readTime: '8分钟',
        image: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20soft%20fabric%20textiles%20in%20blush%20pink%20and%20cream%20tones%20on%20a%20clean%20white%20surface%2C%20elegant%20minimalist%20flat%20lay%2C%20warm%20natural%20light%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=cat-all-1&orientation=landscape',
        slug: '2026-top-10-recommendations',
      },
      {
        id: 'cat-all-2',
        title: '内裤材质终极对比：棉质 vs 莫代尔 vs 真丝',
        excerpt: '不同材质的内裤在透气性、吸湿性、亲肤感上差异巨大。我们做了详细对比测试。',
        date: '2026-08-03',
        readTime: '10分钟',
        image: 'https://readdy.ai/api/search-image?query=Three%20different%20fabric%20textures%20cotton%20modal%20silk%20displayed%20side%20by%20side%20on%20neutral%20background%2C%20macro%20texture%20details%2C%20soft%20lighting&width=800&height=500&seq=cat-all-2&orientation=landscape',
        slug: 'fabric-comparison-guide',
      },
      {
        id: 'cat-all-3',
        title: '女士内裤尺码怎么选？完整测量指南',
        excerpt: '80%的女性穿着不适合自己尺码的内裤！学会正确的臀围、腰围测量方法。',
        date: '2026-08-01',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Elegant%20measuring%20tape%20and%20soft%20fabric%20on%20warm%20cream%20surface%2C%20minimalist%20flat%20lay%2C%20soft%20natural%20light&width=800&height=500&seq=cat-all-3&orientation=landscape',
        slug: 'size-measurement-guide',
      },
      {
        id: 'cat-all-4',
        title: '夏季透气内裤推荐：告别闷热不适',
        excerpt: '夏天穿错内裤的后果很严重！精选透气性最好的女士内裤。',
        date: '2026-07-28',
        readTime: '7分钟',
        image: 'https://readdy.ai/api/search-image?query=Light%20airy%20fabric%20draped%20in%20soft%20pastel%20colors%20by%20sunlit%20window%2C%20breezy%20summer%20vibe%2C%20clean%20minimalist%20aesthetic&width=800&height=500&seq=cat-all-4&orientation=landscape',
        slug: 'summer-breathable-guide',
      },
      {
        id: 'cat-all-5',
        title: '运动内衣与内裤搭配指南',
        excerpt: '运动时的内裤选择直接影响运动体验。无痕、速干、高弹面料怎么选？',
        date: '2026-07-25',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Athletic%20fabric%20textures%20in%20soft%20neutral%20tones%20draped%20on%20light%20wood%20surface%2C%20clean%20modern%20product%20photography&width=800&height=500&seq=cat-all-5&orientation=landscape',
        slug: 'sports-underwear-guide',
      },
      {
        id: 'cat-all-6',
        title: '蕾丝内裤的选购与保养全攻略',
        excerpt: '蕾丝内裤性感又好看，但选不好容易扎皮肤。掌握正确的选购和保养方法。',
        date: '2026-07-22',
        readTime: '5分钟',
        image: 'https://readdy.ai/api/search-image?query=Delicate%20lace%20fabric%20macro%20texture%20in%20soft%20blush%20pink%2C%20intricate%20lace%20patterns%2C%20warm%20natural%20light&width=800&height=500&seq=cat-all-6&orientation=landscape',
        slug: 'lace-underwear-care-guide',
      },
    ],
  },
  {
    id: 'cailiao',
    name: '材质选购',
    description: '棉质、真丝、莫代尔、竹纤维……了解不同材质的特点与差异',
    icon: 'ri-shirt-line',
    articles: [
      {
        id: 'cat-mat-1',
        title: '内裤材质终极对比：棉质 vs 莫代尔 vs 真丝',
        excerpt: '不同材质的内裤在透气性、吸湿性、亲肤感上差异巨大。我们做了详细对比测试，帮你找到最适合自己肤质的内裤材质。',
        date: '2026-08-03',
        readTime: '10分钟',
        image: 'https://readdy.ai/api/search-image?query=Three%20different%20fabric%20textures%20cotton%20modal%20silk%20displayed%20side%20by%20side%20on%20neutral%20warm%20background%2C%20macro%20texture%20details%2C%20soft%20lighting&width=800&height=500&seq=cat-mat-1&orientation=landscape',
        slug: 'fabric-comparison-guide',
      },
      {
        id: 'cat-mat-2',
        title: '纯棉内裤选购指南：支数、工艺全解析',
        excerpt: '不是所有纯棉都一样好。了解棉质内裤的支数、纺织工艺和认证标准，避开劣质产品。',
        date: '2026-07-20',
        readTime: '7分钟',
        image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20fabric%20texture%20close%20up%2C%20soft%20natural%20organic%20cotton%20weave%20details%2C%20warm%20cream%20background%2C%20minimalist%20textile%20photography&width=800&height=500&seq=cat-mat-2&orientation=landscape',
        slug: 'cotton-underwear-guide',
      },
      {
        id: 'cat-mat-3',
        title: '莫代尔内裤为什么这么舒服？深度解析',
        excerpt: '莫代尔面料近年来非常流行，它到底好在哪？和纯棉比有什么优劣？一文讲透。',
        date: '2026-07-15',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Soft%20modal%20fabric%20draped%20elegantly%2C%20silky%20smooth%20textile%20texture%2C%20gentle%20pastel%20tone%2C%20warm%20natural%20light%2C%20minimalist%20product%20photography&width=800&height=500&seq=cat-mat-3&orientation=landscape',
        slug: 'modal-fabric-depth-guide',
      },
    ],
  },
  {
    id: 'kuanshi',
    name: '款式推荐',
    description: '三角裤、平角裤、丁字裤、高腰款……找到最适合你的内裤款式',
    icon: 'ri-pantone-line',
    articles: [
      {
        id: 'cat-style-1',
        title: '蕾丝内裤的选购与保养全攻略',
        excerpt: '蕾丝内裤性感又好看，但选不好容易扎皮肤、洗几次就变形。掌握正确的选购和保养方法。',
        date: '2026-07-22',
        readTime: '5分钟',
        image: 'https://readdy.ai/api/search-image?query=Delicate%20lace%20fabric%20macro%20texture%20in%20soft%20blush%20pink%2C%20intricate%20lace%20patterns%2C%20warm%20natural%20light%2C%20feminine%20elegant&width=800&height=500&seq=cat-style-1&orientation=landscape',
        slug: 'lace-underwear-care-guide',
      },
      {
        id: 'cat-style-2',
        title: '三角裤 vs 平角裤：哪种更适合你？',
        excerpt: '三角裤和平角裤各有优势，我们从舒适度、搭配、运动表现等维度全面对比。',
        date: '2026-07-18',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Two%20elegant%20fabric%20swatches%20in%20soft%20neutral%20tones%20arranged%20side%20by%20side%20on%20cream%20linen%2C%20clean%20minimalist%20flat%20lay%2C%20editorial%20photography&width=800&height=500&seq=cat-style-2&orientation=landscape',
        slug: 'brief-vs-boyshorts',
      },
      {
        id: 'cat-style-3',
        title: '丁字裤到底好不好？优缺点全面分析',
        excerpt: '丁字裤一直存在争议，我们客观分析了它的优缺点和适宜人群，帮你看清是否适合自己。',
        date: '2026-07-12',
        readTime: '5分钟',
        image: 'https://readdy.ai/api/search-image?query=Minimalist%20elegant%20fabric%20draped%20in%20warm%20neutral%20tone%2C%20delicate%20soft%20folds%2C%20clean%20aesthetic%2C%20gentle%20lighting%2C%20feminine%20editorial%20style&width=800&height=500&seq=cat-style-3&orientation=landscape',
        slug: 'thong-pros-cons-analysis',
      },
    ],
  },
  {
    id: 'changjing',
    name: '场景选购',
    description: '日常通勤、运动健身、特殊日子……不同场景下的内裤选择大不同',
    icon: 'ri-sun-line',
    articles: [
      {
        id: 'cat-scene-1',
        title: '夏季透气内裤推荐：告别闷热不适',
        excerpt: '夏天穿错内裤的后果很严重！精选透气性最好的女士内裤，让你整个夏天清爽舒适。',
        date: '2026-07-28',
        readTime: '7分钟',
        image: 'https://readdy.ai/api/search-image?query=Light%20airy%20fabric%20draped%20in%20soft%20pastel%20colors%20by%20sunlit%20window%2C%20breezy%20summer%20vibe%2C%20clean%20minimalist%20aesthetic&width=800&height=500&seq=cat-scene-1&orientation=landscape',
        slug: 'summer-breathable-guide',
      },
      {
        id: 'cat-scene-2',
        title: '运动内衣与内裤搭配指南：运动也要舒适',
        excerpt: '运动时的内裤选择直接影响运动体验。无痕、速干、高弹面料全方位解读。',
        date: '2026-07-25',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Athletic%20fabric%20textures%20in%20soft%20neutral%20tones%20draped%20on%20light%20wood%2C%20clean%20modern%20product%20photography&width=800&height=500&seq=cat-scene-2&orientation=landscape',
        slug: 'sports-underwear-guide',
      },
      {
        id: 'cat-scene-3',
        title: '经期专用内裤怎么选？舒适防漏全攻略',
        excerpt: '经期专用内裤近年来越来越受欢迎，防漏、舒适、易清洗，我们帮你挑选最适合的。',
        date: '2026-07-10',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Soft%20comforting%20fabric%20in%20warm%20dusty%20rose%20tone%2C%20gentle%20folds%20and%20texture%2C%20minimalist%20flat%20lay%2C%20calming%20aesthetic%2C%20warm%20natural%20light&width=800&height=500&seq=cat-scene-3&orientation=landscape',
        slug: 'period-underwear-guide',
      },
    ],
  },
  {
    id: 'pinpai',
    name: '品牌推荐',
    description: '30+品牌真实评测，从平价到高端，帮你找到最值得入手的品牌',
    icon: 'ri-award-line',
    articles: [
      {
        id: 'cat-brand-1',
        title: '2026年最值得入手的10款女士内裤推荐',
        excerpt: '经过30天实测对比，从舒适度、透气性、耐穿性三个维度，为你精选出今年最值得购买的女士内裤。',
        date: '2026-08-05',
        readTime: '8分钟',
        image: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20soft%20fabric%20textiles%20in%20blush%20pink%20and%20cream%20tones%20on%20clean%20white%20surface%2C%20elegant%20minimalist%20flat%20lay&width=800&height=500&seq=cat-brand-1&orientation=landscape',
        slug: '2026-top-10-recommendations',
      },
      {
        id: 'cat-brand-2',
        title: '平价内裤品牌大比拼：30元以下谁最强？',
        excerpt: '预算有限也能穿得舒适。我们测试了10个平价品牌的内裤，选出了性价比之王。',
        date: '2026-07-08',
        readTime: '7分钟',
        image: 'https://readdy.ai/api/search-image?query=Multiple%20fabric%20swatches%20in%20various%20neutral%20tones%20arranged%20in%20grid%20pattern%2C%20clean%20minimalist%20flat%20lay%2C%20soft%20lighting&width=800&height=500&seq=cat-brand-2&orientation=landscape',
        slug: 'budget-brands-comparison',
      },
      {
        id: 'cat-brand-3',
        title: '高端内裤值不值得买？千元级实测体验',
        excerpt: '高端内裤动辄几百上千，它们和普通内裤有什么本质区别？我们买了5个高端品牌实测。',
        date: '2026-07-05',
        readTime: '8分钟',
        image: 'https://readdy.ai/api/search-image?query=Luxurious%20silk%20fabric%20draped%20elegantly%20on%20marble%20surface%2C%20warm%20champagne%20lighting%2C%20premium%20textile%20photography%2C%20sophisticated%20editorial&width=800&height=500&seq=cat-brand-3&orientation=landscape',
        slug: 'luxury-underwear-review',
      },
    ],
  },
  {
    id: 'chima',
    name: '尺码指南',
    description: '精准测量、正确选码，告别不合身的内裤',
    icon: 'ri-ruler-line',
    articles: [
      {
        id: 'cat-size-1',
        title: '女士内裤尺码怎么选？完整测量指南',
        excerpt: '80%的女性穿着不适合自己尺码的内裤！学会正确的臀围、腰围测量方法，找到最适合自己的尺码。',
        date: '2026-08-01',
        readTime: '6分钟',
        image: 'https://readdy.ai/api/search-image?query=Elegant%20measuring%20tape%20and%20soft%20fabric%20on%20warm%20cream%20surface%2C%20minimalist%20flat%20lay%2C%20soft%20natural%20light&width=800&height=500&seq=cat-size-1&orientation=landscape',
        slug: 'size-measurement-guide',
      },
      {
        id: 'cat-size-2',
        title: '不同品牌尺码对照表：别再买错号了',
        excerpt: '每个品牌的尺码标准都不一样！我们整理了主流品牌的尺码对照表，一查便知。',
        date: '2026-06-28',
        readTime: '4分钟',
        image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20fabric%20swatches%20with%20measurement%20markings%2C%20neutral%20warm%20background%2C%20precise%20minimalist%20flat%20lay%2C%20professional%20textile%20photography&width=800&height=500&seq=cat-size-2&orientation=landscape',
        slug: 'brand-size-chart-comparison',
      },
    ],
  },
];

export const categoryTabs = categoryGroups.map((g) => ({
  id: g.id,
  name: g.name,
  icon: g.icon,
}));